import * as LabelPrimitive from "@radix-ui/react-label";
import * as React from "react";

import { cn } from "@/core/utils/func/cn";

const Label = React.forwardRef<
  React.ElementRef<typeof LabelPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof LabelPrimitive.Root> & {
    name?: string;
    label?: string;
    errorMessage?: string | { message?: string } | undefined;
    colorLabel?: string;
  }
>(
  (
    { className, label, name, errorMessage, colorLabel, children, ...props },
    ref
  ) => {
    const content = label ?? children;
    if (content == null || content === false) return null;
    return (
      <LabelPrimitive.Root
        ref={ref}
        className={cn(
          "mb-0.5 block text-sm font-medium leading-6 text-ellipsis overflow-hidden whitespace-nowrap",
          !!errorMessage && "text-destructive",
          colorLabel || "text-muted-foreground",
          className
        )}
        htmlFor={name ?? props.htmlFor}
        {...props}
      >
        {content}
      </LabelPrimitive.Root>
    );
  }
);
Label.displayName = LabelPrimitive.Root.displayName;

export { Label };
